import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Image = styled.img.attrs(({ src }) => src)`
  width: ${({ size }) => (Number.isInteger(size) ? `${size}px` : size)};
  height: ${({ size }) => (Number.isInteger(size) ? `${size}px` : size)};
  background-color: #ffffff;
  border-radius: 0px;
  overflow: hidden;
  ${({ styles }) => styles};
`;

const Avatar = ({ src, size, styles }) => (<Image src={src} size={size} styles={styles} />);

Avatar.propTypes = {
  src: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  styles: PropTypes.array,
};

Avatar.defaultProps = {
  src: '',
  size: 50,
  styles: [],
};

export default Avatar;
